import React from 'react';
import "./index.css";

const DessertsAffichage = (props) => {

    return (
        <div id="desserts" className="menus-content">
            <h1>Desserts</h1>
            <div className="menus__inside">
                <ul className="ul_carte">
                    {
                        props.data.dessert.map((dessert, index) => {
                            return <li key={dessert}><span>{dessert}</span> <span className="dots"></span> <span className="carte_prix">{props.data.prix[index]}</span></li>
                        })
                    }

                    <h2>{props.data.sous_cat.title}</h2>
                    {
                        props.data.sous_cat.dessert.map((dessert, index) => {
                            return <li key={dessert}><span>{dessert}</span> <span className="dots"></span> <span className={"carte_prix "+ (dessert.includes("boules") && ("dessert_glace_prix"))}>{props.data.sous_cat.prix[index]}</span></li>
                        })
                    }
                </ul>
            </div>
        </div>
    );

};

export default DessertsAffichage;